import { Input } from "antd";

export const ReadOnlyInput = ({ value, width }) => {
  const st = width !== undefined ? { width } : {};
  return <Input value={value} disabled style={st} />;
};
